import React from 'react'

/**
 * GoldButton - Reusable gold gradient button component.
 *
 * Design spec:
 *   height: 54px, border-radius: 0.5rem (rounded-lg)
 *   background: linear-gradient(180deg, #EFD43C 0%, #CB7D00 100%)
 *   border: 1px solid #FFFFFF4D
 *   font: Rubik SemiBold 16px / 28.12px, color: #FFFFFF
 *
 * Usage:
 *   <GoldButton>Change name</GoldButton>
 *   <GoldButton type='submit' disabled={loading} onClick={fn}>Submit</GoldButton>
 *   <GoldButton fullWidth={false} className='min-w-[110px]'>Save</GoldButton>
 *
 * Props:
 *   children    - button label / content
 *   type        - button type (default: 'button')
 *   disabled    - disabled state
 *   onClick     - click handler
 *   fullWidth   - stretch to fill container width (default: true)
 *   className   - extra Tailwind classes to override / extend
 */
const GoldButton = ({
  children,
  type = 'button',
  disabled = false,
  onClick,
  fullWidth = true,
  className = '',
  ...rest
}) => {
  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      className={[
        fullWidth ? 'w-full' : '',
        'px-4 py-2',
        'inline-flex items-center justify-center',
        'rounded-lg',
        'border border-[#FFFFFF4D]',
        'bg-gold-btn-180',
        'font-semibold text-base leading-[28.12px] tracking-normal text-white',
        'cursor-pointer select-none',
        'transition-opacity duration-200',
        'hover:opacity-90 active:opacity-80',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className
      ]
        .filter(Boolean)
        .join(' ')}
      {...rest}
    >
      {children}
    </button>
  )
}

export default GoldButton
